module.exports = __webpack_public_path__ + "assets/img/icon_famliy_time.3c249643.png";